let publicFunc = {
  qq:()=>{
    console.log("qwsqeshdksahdsa")
  }
}

export  default  publicFunc
